import { Backdrop, Card, CardActionArea, CircularProgress, Fade, Grid, Icon, makeStyles, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import { blue, blueGrey, grey, indigo, purple } from "@material-ui/core/colors";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../constants/routes";
import LangSelect from "../Navigation/LangSelect";
import { useTranslation } from "react-i18next";
import { AuthUserContext } from "../Session";
import { useParams } from "react-router-dom";
import { withFirebase } from "../Firebase";
import background from "../../constants/images/fondo.b41024b9.png";

const Ermua2022 = (props) => {
    const history = useHistory();
    const { formId } = useParams();
    const { t } = useTranslation();
    const classes = useStyles();
    const { firebase } = props;

    const [isLoading, setIsLoading] = useState(true);
    const [animation, setAnimation] = useState(false);
    const [openBackDrop, setOpenBackDrop] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
            !!firebase.currentUser() && history.push(ROUTES.ONSITE_TRAINING);
        }, 2000);
        setAnimation(true);
        setTimeout(() => {
            setAnimation(false);
            /* actualización para el grupo de Fagor */
            history.push(ROUTES.RESCUERS_SIGNUP.replace(":formId", formId));
        }, 1900);
    }, []);

    if (isLoading) {
        return (
            <Grid
                container
                style={{ minHeight: "100vh", backgroundImage: `linear-gradient(-45deg,rgba(225, 190, 231,.5),rgba(187, 222, 251,.3)),url(${background})` }}
                justify="center"
                alignItems="center"
            >
                <Grid item xs={10} container justify="center">
                    <Fade in={animation}>
                        <Lottie animationData={require("../../assets/formLoading.json")} autoPlay />
                    </Fade>
                </Grid>
            </Grid>
        );
    } else {
        return (
            <Grid
                container
                justify="center"
                alignItems="center"
                style={{ backgroundImage: `linear-gradient(-45deg,rgba(225, 190, 231,.1),rgba(187, 222, 251,.1)),url(${background})`, minHeight: "100vh" }}
            >
                <AuthUserContext.Consumer>
                    {(authUser) =>
                        !authUser && (
                            <Grid item xs={12} lg={10} container justify="flex-end" style={{ paddingTop: 16 }}>
                                <LangSelect icon style={{ color: "white" }} />
                            </Grid>
                        )
                    }
                </AuthUserContext.Consumer>

                <Grid item xs={12} container justify="center" spacing={2} style={{ minHeight: "90vh", marginBottom: 0 }}>
                    <Grid item xs={12} lg={8} container alignItems="center" justify="center" direction="column">
                        <Typography variant="h4" style={{ color: grey[50], marginBottom: "1.35rem" }} align="center">
                            {t("newCourseTitle")}
                        </Typography>
                        <Typography variant="h6" style={{ color: blueGrey[50], textAlign: "justify" }} color="textSecondary">
                            {t("newCourseSubtitle")}
                        </Typography>
                    </Grid>

                    <Grid item container spacing={2} justify="center" style={{ marginBottom: 0 }}>
                        <Grid item xs={8} sm={4} sd={4} md={3} lg={2}>
                            <Card style={{ borderRadius: 12 }} elevation={2}>
                                <CardActionArea
                                    onClick={() => {
                                        setOpenBackDrop(true);
                                        setTimeout(() => {
                                            history.push(ROUTES.ONSITE_TRAINING);
                                        }, 750);
                                    }}
                                >
                                    <Grid
                                        item
                                        xs={12}
                                        style={{ backgroundColor: purple[50], borderBottomLeftRadius: 9, borderBottomRightRadius: 9, minHeight: "25vh", padding: 16 }}
                                        container
                                        alignItems="center"
                                        justify="center"
                                    >
                                        <svg style={{ width: "15vh", height: "15vh" }} viewBox="0 0 24 24">
                                            <path
                                                fill={purple[300]}
                                                d="M16 8C16 10.21 14.21 12 12 12C9.79 12 8 10.21 8 8L8.11 7.06L5 5.5L12 2L19 5.5V10.5H18V6L15.89 7.06L16 8M12 14C16.42 14 20 15.79 20 18V20H4V18C4 15.79 7.58 14 12 14Z"
                                            />
                                        </svg>
                                    </Grid>
                                    <Grid item xs={12} container style={{ padding: 16, minHeight: 86 }} alignItems="center" justify="center">
                                        <Typography variant="body1" style={{ fontWeight: "500", fontSize: "1.1rem" }}>
                                            {t("iamVolunteer")}
                                        </Typography>
                                    </Grid>
                                </CardActionArea>
                            </Card>
                        </Grid>

                        <Grid item xs={8} sm={4} sd={4} md={3} lg={2}>
                            <Card style={{ borderRadius: 12 }} elevation={2}>
                                <CardActionArea
                                    onClick={() => {
                                        history.push(ROUTES.RESCUERS_SIGNUP.replace(":formId", formId));
                                    }}
                                >
                                    <Grid
                                        item
                                        xs={12}
                                        style={{ backgroundColor: indigo[50], borderBottomLeftRadius: 9, borderBottomRightRadius: 9, minHeight: "25vh", padding: 16 }}
                                        container
                                        alignItems="center"
                                        justify="center"
                                    >
                                        <svg style={{ width: "15vh", height: "15vh" }} viewBox="0 0 24 24">
                                            <path fill={indigo[500]} d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" />
                                        </svg>
                                    </Grid>
                                    <Grid item xs={12} container style={{ padding: 16, minHeight: 86 }} alignItems="center" justify="center">
                                        <Typography variant="body1" style={{ fontWeight: "500", fontSize: "1.1rem" }}>
                                            {t("wantToBeVolunteer")}
                                        </Typography>
                                    </Grid>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
                <Backdrop open={openBackDrop} className={classes.backdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </Grid>
        );
    }
};

export default withFirebase(Ermua2022);

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
}));
